import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";


@Component({
  selector: 'lcms-session-viewer',
  standalone: true,
  imports: [CommonModule  , TranslateModule],
  templateUrl: './session-viewer.component.html',
  styleUrls: ['./session-viewer.component.scss'],
})
export class SessionViewerComponent {
  @Input() items : any
}
